import { Injectable } from '@angular/core';

import { CookieService } from '@frontend/vanilla/core';

import { ChannelType } from '../config/appConstants';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root',
})
export class EventService {
    private sessionInfo: any;
    private isNativeApp: any;
    constructor(
        private dataService: DataService,
        private cookieService: CookieService,
    ) {
        this.sessionInfo = this.dataService?.sessionInfo;
        this.isNativeApp = [ChannelType.AN, ChannelType.IN].includes(this.sessionInfo?.channelId);
    }

    raiseCloseEvent(ignoreTimeout: any) {
        let timeout = this.sessionInfo?.stake || ignoreTimeout ? 0 : 5000;

        setTimeout(() => {
            const clientScheme = this.cookieService.get('clientScheme');
            if (clientScheme) {
                const appUrl = `${clientScheme}://?event=closeSfSafariWindow`;
                document.location.href = appUrl;
            } else {
                if (this.isNativeApp) {
                    const url = 'bwinex://?event=qd_close';
                    this.createFrame(url);
                }
                parent.postMessage('action=close', '*');
            }
        }, timeout);
    }

    raiseDepositEvent(url: string) {
        if (this.isNativeApp) {
            this.createFrame(url);
        }
    }
    createFrame(url: string) {
        const frame = document.createElement('IFRAME');
        frame.setAttribute('src', url);
        frame.setAttribute('border', '0');
        frame.setAttribute('width', '0');
        frame.setAttribute('height', '0');
        frame.setAttribute('frameborder', '0');
        document.body.appendChild(frame);
    }

    raiseUpdateBalanceEvent() {
        parent.postMessage('action=updateBalance', '*');
    }
}
